import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormationService {
  public url: string;
  // public idFormationList: string;
  // public select: string;
  // public filter: string;

  constructor(
    private http: HttpClient,
  ) {
    this.url = environment.url  + 'api/formations/';
    // this.idFormationList = environment.idFormationList;
    // this.select = "$select=ID,Title,Descripcion,Imagen";
  }

  public getAll() {
    // return this.http.get(this.url + "_api/Web/Lists(" + this.idFormationList + ")/Items?" + this.select);
    return this.http.get(this.url);
  }

  public getById(programId: number) {
    // this.filter = "&$filter=Id eq " + programId;
    // return this.http.get(this.url + "_api/Web/Lists(" + this.idFormationList + ")/Items?$select=Id,Title" + this.filter);
    return this.http.get(this.url + programId);
  }
}
